// LayoutContainer.jsx

import React from "react";
import NavBar from "../Componenet/Navigation/NavBar";
import "./LayoutContainer.scss";
export default function LayoutContainer({ children,isWhite=false }) {
  return (
    <div className="main-wrap">
      {" "}
      <NavBar isWhite={isWhite} />
      {children}
    </div>
  );
}
